import { commonApi } from '@common/utils/baseQuery';
import { IEvent, IEventById } from '@features/event/api/eventApi.type';

export const preMatchApi = commonApi.injectEndpoints({
  endpoints: (build) => ({
    fetchEventById: build.query<IEvent | void, string | number>({
      query: (id) => `/prematches/${id}`,
      extraOptions: { useToken: false },
      transformResponse: (response: IEventById) => {
        if (Array.isArray(response?.events) && response.events.length) {
          return {
            ...response.events[0],
            alias: response.alias,
            sport: response.sport,
            sportId: response.s,
          };
        }
      },
    }),
  }),
});

export const { useFetchEventByIdQuery } = preMatchApi;

export const selectPreMatchEventById = (eventId: string | number) => {
  return preMatchApi.endpoints.fetchEventById.select(eventId);
}
